import { render, staticRenderFns } from "./AvatarEditorModal.vue?vue&type=template&id=6f2d2478&scoped=true"
import script from "./AvatarEditorModal.vue?vue&type=script&lang=js"
export * from "./AvatarEditorModal.vue?vue&type=script&lang=js"
import style0 from "./AvatarEditorModal.vue?vue&type=style&index=0&id=6f2d2478&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d2478",
  null
  
)

export default component.exports